import { makeStyles } from "@material-ui/core";
import { Colors } from "../../../styles/Colors";

export const useStyles = makeStyles(() => ({
    myRingGroupRow: {
        width: '100%',
        height: 20,
        display: 'flex',
        flexDirection: 'row',
        padding: '18px 15px'
    },
    ringGroupCodeLabel: {
        lineHeight: '20px',
        fontWeight: 500,
        fontSize: 16,
        textAlign: 'center',
        verticalAlign: 'middle',
        color: Colors.Text,
        width: 68,
    },
    ringGroupNameLabel: {
        lineHeight: '20px',
        fontWeight: 600,
        fontSize: 16,
        textAlign: 'center',
        verticalAlign: 'middle',
        color: Colors.Text,
        width: 156,
        marginLeft: 29
    },
    switch: {
        marginTop: 0,
        marginBottom: 0,
        height: 'unset',
    },
    ringGroupSwitchLabel: {
        lineHeight: '20px',
        fontWeight: 400,
        fontSize: 16,
        textAlign: 'center',
        verticalAlign: 'middle',
        color: Colors.Text,
    },
    ringGroupSwitchContainer: {
        width: 'fit-content',
        marginLeft: 7,
        marginTop: -9,
    }
}));